import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';
import MultiHalfText from '../../../components/MultiHalfText';

export default function Page01({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<MultiHalfText first='Upper Body / Core' second='Workout 04' mt={true} />
			<RoundScreen
				isNumbered={false}
				rounds={[
					[
						{
							header: '(A) Back',
							value: 'Bent-over Rows w / DB',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 12',
						},
						{
							header: 'ABS / Core',
							value: 'Crunches',
						},
						{
							header: 'Sec / Minutes',
							value: '30 secs',
						},
					],
					[
						{
							header: '(A) Back',
							value: 'DeadLifts w / DB',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 12',
						},
						{
							header: 'ABS / Core',
							value: 'Bicycles',
						},
						{
							header: 'Sec / Minutes',
							value: '25 secs',
						},
					],
					[
						{
							header: '(A) Back',
							value: 'Pull Up w / RB (optional)',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 10',
						},
						{
							header: 'ABS / Core',
							value: 'Rest',
						},
						{
							header: 'Sec / Minutes',
							value: '...',
						},
					],
					[
						{
							header: '(A) Back',
							value: 'Plank Row',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 10',
						},
						{
							header: 'ABS / Core',
							value: 'Russian Twists',
						},
						{
							header: 'Sec / Minutes',
							value: '30 secs',
						},
					],
					[
						{
							header: '(A) Back',
							value: 'Jog in Place',
						},
						{
							header: 'Sets / Reps',
							value: '30 secs',
						},
						{
							header: 'ABS / Core',
							value: 'Roll Ups',
						},
						{
							header: 'Sec / Minutes',
							value: '30 secs',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
